import Slider from "../components/Slider"
import {useEffect, useState} from "react";
import org_api from "../api/admin/admin_orgs"



const ReportLengthChooseAllowToggle = (props) => {

    const [enableReportLengthChooseAllow, setEnableReportLengthChooseAllow] = useState(true)
    const [enableUpdate, setEnableUpdate] = useState(false)

    useEffect(() => {
        setEnableReportLengthChooseAllow(props.reportLengthAllow ? props.reportLengthAllow : false)
        setEnableUpdate(true)
    }, []);

    useEffect(() => {
        updateReportLengthChooseAllow()
    }, [enableReportLengthChooseAllow]);

    const updateReportLengthChooseAllow = () => {
        if(!enableUpdate) return;
        org_api.putReportLengthChooseAllow(props.org_id, {
            "allow_report_length_select": enableReportLengthChooseAllow
        })
    }

    return (
        <div className="commercial-valuation-requests-toggle-container">
            <div className="commercial-valuation-requests-toggle-title">Report length</div>
            <div className="commercial-valuation-requests-toggle">
                <Slider state={enableReportLengthChooseAllow} update={setEnableReportLengthChooseAllow.bind(this)}
                        text="Allow clients to select Report Length on valuation search bar"
                />
            </div>
        </div>
    )
}


export default ReportLengthChooseAllowToggle
